import React from 'react';

import { Avatar } from '../components/Avatar';

// Maps an array of users to an array of selectable avatars. Appends "(me)" to the
// :current_user's name. Most often used by the <SelectChip /> and the <SelectField />.
export const peopleOptions = ({ currentUserId, users }) =>
  users.map(({ avatarColor, fullName, id, initials }) => {
    const label = currentUserId === id ? `${fullName} (me)` : fullName;

    return {
      icon: <Avatar backgroundColor={avatarColor} initials={initials} size="sm" />,
      label,
      value: id,
    };
  });
